import React from "react";

function WatchesJewelryDetails({ product }) {
    if (!product) return <p>Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const isWatch = product.category === "Saat";

    return (
        <div className="product-details">
            <h3 className="product-details-title">Saat və Zərgərlik Məhsul Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Ad:</strong> {product.name || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Kateqoriya:</strong> {product.category || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Brend:</strong> {product.brand || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Material:</strong> {product.material || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cins:</strong> {product.gender || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>İstehsal növü:</strong> {product.handmade || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Vəziyyət:</strong> {product.condition || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    {isWatch ? (
                        <>
                            <div className="product-details-item"><strong>Saat tipi:</strong> {product.watchType || "Bilinmir"}</div>
                            <div className="product-details-item"><strong>Kəmər materialı:</strong> {product.strapMaterial || "Bilinmir"}</div>
                            <div className="product-details-item"><strong>Mexanizm tipi:</strong> {product.mechanismType || "Bilinmir"}</div>
                            <div className="product-details-item"><strong>Qutu:</strong> {getStatus(product.hasBox, "Var", "Yoxdur")}</div>
                            <div className="product-details-item"><strong>Sertifikat:</strong> {getStatus(product.hasCertificate, "Var", "Yoxdur")}</div>
                        </>
                    ) : (
                        <>
                            <div className="product-details-item"><strong>Daş tipi:</strong> {product.stoneType || "Bilinmir"}</div>
                            <div className="product-details-item"><strong>Karat:</strong> {product.karat || "Bilinmir"}</div>
                            <div className="product-details-item"><strong>Çəki:</strong> {product.weightGrams ? `${product.weightGrams} qram` : "Bilinmir"}</div>
                        </>
                    )}
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default WatchesJewelryDetails;
